/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardCass from 'solis/logic/board/cass';


// cpp create_board_anchor_args minus `user`. Driven by the dedicated attach flow,
// not the stacked panel, so it is not registered in solis/claude/action.
const buildArgs = ({ board, sourceColony, targetColony, transform }) =>
{
  const args = {};

  args.galaxy = board.cass.galaxy;
  args.board = board.cass.id;

  args.source_colony = sourceColony ? sourceColony.cass.id : null;
  args.target_colony = targetColony;

  args.transform = transform ? transform.toJSON() : null;

  return args;
};


// Maps the placement result (computed in placement.js) to issues, mirroring the cpp
// attach guards: the board still accepts colonies, no overlap, and adjacency to a board colony.
const validate = ({ board, now, account, galaxy, transform, conflict, targetColony }) =>
{
  if (transform === null)
  {
    return { valid: false, issues: [ 'Pick a source hex and a board hex' ] };
  }

  const issues = [];

  const cass = new BoardCass(board);

  if (!cass.hasEnoughDurationForAttach(now))
  {
    issues.push('Board is closed for attaching');
  }

  if (!cass.isAccountWithinTerritoryRange(account, galaxy))
  {
    issues.push('Account territory isn\'t within board range');
  }

  if (conflict)
  {
    issues.push('Placement overlaps an existing zone');
  }

  if (targetColony === null)
  {
    issues.push('Placement must touch a colony on the board');
  }

  return { valid: issues.length === 0, issues };
};


export default
{
  type: 'solis/board/anchor/create',

  buildArgs,
  validate,
};
